<script>
import { mapGetters } from 'vuex'
import Dropdown from '@/components/atoms/Dropdown'
import Modal from '@/components/atoms/Modal'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import Fitlers from '@/modules/mixins/filters'
export default {
    name: 'TagsSelectHeader',
    components: { InputCheckbox, Modal, Dropdown },
    mixins: [Fitlers],
    data() {
        return {
            selectedTags: [],
            selectedFilters: [],
        }
    },
    computed: {
        ...mapGetters({
            groups: 'tags/groups',
            loaded: 'tags/loaded',
            restaurantFilters: 'site/restaurantFilters',
            currency: 'site/currency',
        }),
        hasActiveCanteen() {
            return !!this.$store.getters['active/canteen']?.id
        },
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
    },
    watch: {
        '$route.query': {
            immediate: true,
            handler(query) {
                this.selectedTags =
                    query.tags && query.tags.length >= 0
                        ? typeof query.tags === 'string'
                            ? [parseInt(query.tags)]
                            : query.tags.map((tag) => parseInt(tag))
                        : []
                this.selectedFilters = []
                this.filters.forEach((filter) => {
                    if (query[filter.key]) this.selectedFilters.push(filter.key)
                })
            },
        },
    },
    methods: {
        open() {
            this.$refs.TagsHeader.openModal()
        },
        close() {
            this.$refs.TagsHeader.closeModal()
        },
        show(groupId) {
            return [1, 2, 3].find((id) => id === groupId)
        },
        apply() {
            this.setQuery(
                {
                    ...{
                        tag_names: this.selectedTags?.length ? this.selectedTags : undefined,
                    },
                    ...this.filters.reduce((p, c) => {
                        p[c.key] = this.selectedFilters.includes(c.key)
                            ? this.restaurantFilters[c.key] || true
                            : undefined
                        return p
                    }, {}),
                },
                'restaurant-list',
                {
                    pageLoader: false,
                },
                () => {
                    this.$store.dispatch('tags/fetch', this.$route)
                    this.close()
                }
            )
        },
        clear() {
            this.setQuery(
                {
                    ...{
                        tag_names: undefined,
                    },
                    ...this.filters.reduce((p, c) => {
                        p[c.key] = undefined
                        return p
                    }, {}),
                },
                'restaurant-list',
                {
                    pageLoader: false,
                },
                () => {
                    this.$store.dispatch('tags/fetch', this.$route)
                    this.close()
                }
            )
        },
    },
}
</script>

<template lang="pug">
.tag-select-header
    button.btn.btn-dark.btn-pill.btn-icon.btn-sm(@click="open" :aria-label="`open-${$t('labels.filters')}`" :class="{'active': selectedTags.length || selectedFilters.length}")
        icon(icon="fa-solid fa-sliders-h")
    modal(ref="TagsHeader" @close="close" scroll)
        template(v-slot:header)
            .modal-header-text {{$t('labels.filters')}}
        template(v-slot:body)
            input-checkbox.w-100.py-6.px-6(
                v-for="(filter, index) in filters"
                v-if="!filter.hide"
                v-model="selectedFilters"
                :class="{'border-top': index}"
                :data="filter.key"
                :key="`generalFilter-${index}`"
                :disabled="hasActiveCanteen") {{filter.label}}
            template(v-for="(group, index) in groups" v-if="show(group.tag_group.id)")
                label.w-100.h5.mb-0.py-5.px-6.border-top.border-bottom.bg-f7(:key="`filterGroupTitle-${index}`") {{group.tag_group.name_token}}
                input-checkbox.w-100.py-6.px-6(
                    v-for="(filter, groupIndex) in group.items"
                    v-model="selectedTags"
                    :class="{'border-top': groupIndex}"
                    :data="filter.id"
                    :disabled="hasActiveCanteen"
                    :key="`filterMobile-${index}-${groupIndex}`") {{filter.name_token}}
                    span.ml-2.text-b2.text-sm  ({{filter.restaurant_count}})
        template(v-slot:footer)
            button.btn.btn-primary.btn-block(@click="apply") {{$t('base.apply')}}
            button.btn.btn-secondary.btn-block(@click="clear") {{$t('base.clear_all')}}
</template>
